import { Fragment } from 'react';
import ConsentsAgreements from './ConsentsAgreements';
import ConsentsDisclaimer from './ConsentsDisclaimer';
import ConsentsError from './ConsentsError';
import ConsentHomeBody from './ConsentHomeBody';
import ConsentsTitle from './ConsentsTitle';
import { consentAppSelectors } from 'redux/slices/consent.slice';
import { useSearchParams } from 'react-router-dom';
import { LoadingPage } from '@act/storybook';

const ConsentsHome = () => {
  const [params] = useSearchParams();
  const key = params.get('key');
  const consentState = consentAppSelectors.useSelectConsentState();

  const isErrorState =
    !key || consentState.hasLinkExpired || consentState.status === 'failed';
  const isSuccessState = !isErrorState && consentState.status === 'success';
  const isLoadingState =
    !isErrorState && !isSuccessState && consentState.status === 'loading';

  return (
    <ConsentHomeBody>
      {isErrorState && <ConsentsError />}
      {isSuccessState && (
        <Fragment>
          <ConsentsTitle />
          <ConsentsDisclaimer />
          <ConsentsAgreements linkKey={key} />
        </Fragment>
      )}
      {isLoadingState && <LoadingPage />}
    </ConsentHomeBody>
  );
};

export default ConsentsHome;
